import { useSubscribeToPublicWebsocketEvent } from '~/core/shared/contexts/websockets';
import { buildListChannelName } from '../../logic/buildListChannelName';
import { ListPrivateWebsocketEvent } from '../../types/ListPrivateWebsocketEvent';
import { ListPrivateWebsocketEventPayload } from '../../types/ListPrivateWebsocketEventPayload';

export const useSubscribeToListNoDocumentsToAssign = (
  onUpdate: (
    payload: ListPrivateWebsocketEventPayload[ListPrivateWebsocketEvent.NoDocumentsToAssignEvent],
  ) => void,
): void => {
  useSubscribeToPublicWebsocketEvent(
    buildListChannelName(),
    ListPrivateWebsocketEvent.NoDocumentsToAssignEvent,
    onUpdate,
  );
};
